import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Lightweight fetch + cache for a brand's content categories. Used by
 * Brand Kit forms to populate the "Usable in categories" multi-select.
 */
const _cache = new Map();

export default function useContentCategories(brandId) {
  const [categories, setCategories] = useState(() => _cache.get(brandId) || []);
  const [loading, setLoading] = useState(!_cache.has(brandId));

  useEffect(() => {
    if (!brandId) return;
    if (_cache.has(brandId)) {
      setCategories(_cache.get(brandId));
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    api
      .get(`/brands/${brandId}/content-categories`)
      .then(({ data }) => {
        if (cancelled) return;
        _cache.set(brandId, data);
        setCategories(data);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [brandId]);

  return { categories, loading };
}
